import { render, staticRenderFns } from "./Time.vue?vue&type=template&id=21abcba9&scoped=true&"
import script from "./Time.vue?vue&type=script&lang=ts&"
export * from "./Time.vue?vue&type=script&lang=ts&"
import style0 from "./Time.vue?vue&type=style&index=0&id=21abcba9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21abcba9",
  null
  
)

export default component.exports